export const environment = {
  production: false,
  apiBaseUrl: 'http://localhost:3000/api/v1',
  googleClientId: '',
  appName: 'Tattva',
};
